import React, { forwardRef } from "react";
import DatePicker from "react-datepicker";
import moment from "moment";
import PropTypes from "prop-types";

import "react-datepicker/dist/react-datepicker.css";
import "bootstrap/dist/css/bootstrap.min.css";

function DateTimePickerComponent(props) {
  let { value, onChangeHandler, dateTimestamp } = props;
  
  // Convert string value to Date object if needed
  let dateValue = value;
  if (typeof value === 'string') {
    // If value is a string, convert it to a Date object
    dateValue = new Date(value);
  }
  // if (dateInIso) {
  //   console.group();
  //   console.log(value, "value before")
  //   const month = Number.parseInt(dateInIso.split("-")[1]) - 1;
  //   const date = dateInIso.split("-")[2].split("T")[0]
  //   console.log("month and date", month, date)
  //   modifiedDate.setMonth(month)
  //   modifiedDate.setMonth(month)
  //   modifiedDate.setDate(date)
  //   modifiedDate.setDate(date)
  //   console.log(modifiedDate, "value after")
  //   console.groupEnd();
  // }
  const CustomInput = forwardRef(
    ({ value: valueProp, onClick }, ref) => {
      return (
        // eslint-disable-next-line react/button-has-type
        <button
          className="example-custom-input btn btn-outline-secondary"
          onClick={onClick}
          ref={ref}
        >
          {dateTimestamp}
          {/* {moment(momentDate).format("ddd, DD MMM YYYY")} */}
        </button>
      );
    }
  );

  CustomInput.propTypes = {
    onClick: PropTypes.func.isRequired,
  };

  return (
    <DatePicker
      selected={dateValue}
      onChange={onChangeHandler}
      customInput={<CustomInput />}
    />
  );
}

// #region Prop Types
DateTimePickerComponent.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.instanceOf(Date),
    PropTypes.string
  ]).isRequired,
  onChangeHandler: PropTypes.func.isRequired,
};
// #endregion

export default DateTimePickerComponent;
